// state/userSigninReducer.ts

import { OtpChannel } from '@/core/enums/otp-channel.enum';

export interface UserSigninState {
  id?: string;

  sessionId?: string;
  loginSessionId?: string;

  // Credentials
  userName?: string;
  password?: string;

  // Verification Status
  isVerified: boolean;

  // OTP Channel
  otpChannel?: OtpChannel;
  phoneNumber?: string;
  email?: string;

  // Verify OTP
  otpCode?: string;
  otpReference?: string;
  ecitizenLoginUrl?: string;
}

export const initialUserSigninState: UserSigninState = {
  otpChannel: OtpChannel.Sms,
  isVerified: false,

  // Dev defaults
  userName: '',
  password: '',
  phoneNumber: '',
  email: '',
};

export type UserSigninAction =
  | {
      type: 'UPDATE';
      payload: Partial<UserSigninState>;
    }
  | {
      type: 'RESET';
    };

export const userSigninReducer = (
  state: UserSigninState,
  action: UserSigninAction
): UserSigninState => {
  switch (action.type) {
    case 'UPDATE':
      return {
        ...state,
        ...action.payload,
      };

    case 'RESET':
      return initialUserSigninState;

    default:
      return state;
  }
};